module.exports = __webpack_public_path__ + "img/average-bottom-arrow.9c30dc52.svg";